import React, { useState, useEffect } from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import '../../assets/css/Cogen.css';
import prof from '../../assets/images/prof.svg';
import tw from '../../assets/images/tw.png';
import linkedin from '../../assets/images/in.png';
import { Link, useNavigate } from 'react-router-dom';
import { ReqGet } from '../../config/Requests';
import { Multiselect } from 'multiselect-react-dropdown';
import { toast } from 'react-toastify';

function ProfilePage({ _handleEdit }) {
	let navigate = useNavigate();
	const isLogin = localStorage.getItem('isLogin');
	const userType = isLogin ? localStorage.getItem('userType') : 'public';
	const [profile, setProfile] = useState({});

	const openSocialProfile = link => {
		if (link) {
			const newWindow = window.open(link, '_blank', 'noopener,noreferrer');
			if (newWindow) newWindow.opener = null;
		} else {
			toast.warn('Link is not added');
		}
	};

	const [req, setReq] = useState(false);

	useEffect(() => {
		ReqGet('profile')
			.then(res => {
				setProfile(res.data);
				setReq(true);
			})
			.catch(err => {
				console.log(err.message);
			});
	}, []);

	return (
		<Container fluid='md' className='mt-3'>
			<Row>
				<Col>
					<div className='mt-2 mb-3 recruiter_actions' />
					<div className={'top-actions'}>
						<h4 className={'heading text-orange'}>Profile</h4>
					</div>
				</Col>
				<Col md='auto' style={{ paddingInline: '74px' }}>
					<Button
						className='btn_cancel'
						variant='primary'
						onClick={() => navigate('/')}
					>
						Back{' '}
					</Button>
				</Col>
			</Row>
			<Row className='mt-5'>
				<Col md='1'>
					<img
						className='profile'
						style={{ width: '75px', height: '70px', padding: '2px' }}
						src={
							profile.profile_image === null || !profile.profile_image
								? prof
								: profile.profile_image +
								  '?img=' +
								  Math.random().toString(36).substring(7)
						}
						alt='profile'
					/>
				</Col>
				<Col md='4' className='pl-3 pt-2'>
					{profile.first_name && (
						<span>
							<strong>
								{profile.first_name || profile.name} {profile.last_name}{' '}
							</strong>{' '}
						</span>
					)}{' '}
					<br />
					{req && profile.professional_title !== null && (
						<span className='text-primary'>
							{' '}
							{profile.professional_title.name}{' '}
						</span>
					)}
					{profile.user_type && profile.user_type.length > 0 && (
						<span className='d-block'>
							{profile.user_type.charAt(0).toUpperCase() +
								profile.user_type.slice(1)}
						</span>
					)}
				</Col>
				<Col md={{ offset: 5 }}>
					<Button variant='primary' onClick={_handleEdit}>
						Edit Profile
					</Button>
				</Col>
			</Row>
			<Row className='bg-label mt-4'>
				<Col className='fw-bold p-1 ml-3'> Contact Info </Col>
			</Row>

			<Row>
				<Col>
					<ul className='list-group list-group-flush'>
						<li className='list-group-item font-weight-normal'>
							Phone: <span className='text-primary'>{profile.phone}</span>{' '}
							&nbsp; Second Phone:
							<span className='text-primary'> {profile.phone2}</span>{' '}
						</li>
						<li className='list-group-item font-weight-normal'>
							Work Email: <span className='text-primary'> {profile.email}</span>{' '}
							&nbsp; Personal Email:{' '}
							<span className='text-primary'>{profile.email2}</span>{' '}
						</li>
						<li className='list-group-item font-weight-normal'>
							Address: <span className='text-primary'> {profile.address}</span>
						</li>
						<li className='list-group-item font-weight-normal'>
							City: <span className='text-primary'> {profile?.city?.name}</span>
						</li>
						<li className='list-group-item font-weight-normal'>
							State:{' '}
							<span className='text-primary'> {profile?.state?.name} </span>
						</li>
						{(userType === 'Member' || userType === 'member') && (
							<li className='list-group-item font-weight-normal'>
								Social media link(s):
								<Link onClick={() => openSocialProfile(profile.twit_link)}>
									<img className='m-1' src={tw} alt='twitter' />
								</Link>
								<Link onClick={() => openSocialProfile(profile.linkedin_link)}>
									<img className='m-1' src={linkedin} alt='linkedin' />
								</Link>
							</li>
						)}
						<li className='list-group-item font-weight-normal'></li>
					</ul>
				</Col>
			</Row>
			{(userType === 'Member' || userType === 'member') && (
				<>
					<Row className='bg-label mt-1'>
						<Col className='fw-bold p-1 ml-3'> Availability </Col>
					</Row>

					<Row>
						<Col>
							<ul className='list-group list-group-flush'>
								<li className='list-group-item font-weight-normal'>
									Current Status:{' '}
									<span className='text-primary'>Available</span>
								</li>
								<li className='list-group-item font-weight-normal'>
									Job Preference:{' '}
									<span className='text-primary'>{profile.job_preference}</span>
								</li>

								<li className='list-group-item font-weight-normal'>
									From: {profile.available_start} To: {profile.available_end}
								</li>
								<li className='list-group-item font-weight-normal'></li>
							</ul>
						</Col>
					</Row>

					<Row className='bg-label mt-1'>
						<Col className='fw-bold p-1 ml-3'> Tags </Col>
					</Row>
					<Row>
						<Col>
							<ul className='list-group list-group-flush'>
								<Multiselect
									options={profile.tags}
									placeholder=''
									displayValue='display_name'
									selectedValues={profile.tags}
									disable='true'
									style={{
										chips: { background: 'blue' },
										searchBox: { border: 'hidden', background: 'white' },
									}}
								/>
							</ul>
						</Col>
					</Row>
					<div>
						<Row className='bg-label mt-1'>
							<Col className='fw-bold p-1 ml-3'> References </Col>
						</Row>
						<Row>
							<Col>
								{req &&
									profile.references.map((item, i) => {
										return (
											<ul className='list-group list-group-flush' key={i}>
												<li className='list-group-item font-weight-normal'>
													First Name:{' '}
													<span className='fw-bold'>
														{item.first_name}
													</span>
												</li>
												<li className='list-group-item font-weight-normal'>
													Last Name:{' '}
													<span className='fw-bold'>
														{item.last_name}
													</span>{' '}
												</li>
												<li className='list-group-item font-weight-normal'>
													Email:{' '}
													<span className='fw-bold'>{item.email}</span>{' '}
												</li>
												<li className='list-group-item font-weight-normal'>
													Type of Reference:{' '}
													<span className='fw-bold'>
														{item.type_of_reference}
													</span>{' '}
												</li>
											</ul>
										);
									})}
							</Col>
						</Row>
						<Row className='bg-label mt-1'>
							<Col className='fw-bold p-1 ml-3'> Experiences </Col>
						</Row>
						<Row>
							<Col>
								{req &&
									profile.experiences.map((item, i) => {
										return (
											<ul className='list-group list-group-flush' key={i}>
												<li className='list-group-item fw-bold'>
													Organization:{' '}
													<span className='fw-bold'>
														{item.company}
													</span>{' '}
												</li>
												<li className='list-group-item font-weight-normal'>
													Starting Date:{' '}
													<span className='fw-bold'>
														{item.start_date}
													</span>
												</li>
												<li className='list-group-item font-weight-normal'>
													Ending Date:{' '}
													<span className='fw-bold'>
														{item.end_date}
													</span>{' '}
												</li>
												<li className='list-group-item font-weight-normal'>
													Description:{' '}
													<span className='fw-bold'>
														{item.description}
													</span>{' '}
												</li>
											</ul>
										);
									})}
								<li className='list-group-item font-weight-normal'> </li>
							</Col>
						</Row>
					</div>

					<Row className='bg-label mt-1'>
						<Col className='fw-bold p-1 ml-3'> Supporting Files </Col>
					</Row>

					<Row>
						<Col>
							<ul className='list-group list-group-flush'>
								<li className='list-group-item font-weight-normal'>
									{profile.official_doc}{' '}
								</li>
								<li className='list-group-item font-weight-normal'></li>
							</ul>
						</Col>
					</Row>
				</>
			)}
		</Container>
	);
}

export default ProfilePage;
